// Surface-patch list mutations — create / delete / set-active /
// set-property. Vertex-level edits (add / move / delete / sharp) reuse
// the waypoint-ops module via activeWaypoints(state) routing to the
// active patch's polygon.

import { clearSelection } from './state.js';
import { pushHistory } from './history.js';

export function createPatch(state, notify) {
  if (!Array.isArray(state.trackData.surfacePatches)) state.trackData.surfacePatches = [];
  state.trackData.surfacePatches.push({
    surface: 'gravel',   // common-case default — most tracks have gravel runoff
    closed: true,
    alpha: 0.5,
    polygon: [],
  });
  state.activePatchIdx = state.trackData.surfacePatches.length - 1;
  clearSelection(state);
  pushHistory(state, notify);
}

export function deletePatch(state, idx, notify) {
  const patches = state.trackData.surfacePatches;
  if (!patches || idx < 0 || idx >= patches.length) return;
  patches.splice(idx, 1);
  if (state.activePatchIdx === idx)       state.activePatchIdx = -1;
  else if (state.activePatchIdx > idx)    state.activePatchIdx -= 1;
  clearSelection(state);
  pushHistory(state, notify);
}

export function setActivePatch(state, idx, notify) {
  if (idx === state.activePatchIdx) return;
  state.activePatchIdx = idx;
  clearSelection(state);
  notify();
}

// Curb thickness range — kept in sync with editor UI slider bounds.
// Real F1 curbs are roughly 60–90 cm wide; we clamp to a 2–8 ft window
// so an 8 m gravel-patch thickness can't survive a switch to curb.
const CURB_THICKNESS_MIN_M     = 0.6096; // 2 ft
const CURB_THICKNESS_MAX_M     = 2.4384; // 8 ft
const CURB_THICKNESS_DEFAULT_M = 1.524;  // 5 ft

// Patch a property on the active patch (surface, closed, alpha,
// thickness, curbColor, tarmacColor). Caller chooses live vs commit
// history via the editor's applyChange / applyChangeLive pattern.
//
// Curb is always an open band — switching to curb forces closed=false
// even if the patch was authored as a closed loop. Real curbs trace
// the corner edge, not bound an area. Thickness gets clamped/seeded
// into the curb range so a gravel→curb switch doesn't leave behind
// an absurd 8 m wide curb.
export function updateActivePatch(state, patch) {
  const p = state.trackData.surfacePatches?.[state.activePatchIdx];
  if (!p) return;
  Object.assign(p, patch);
  if (p.surface === 'curb') {
    p.closed = false;
    if (p.thickness == null
        || p.thickness < CURB_THICKNESS_MIN_M
        || p.thickness > CURB_THICKNESS_MAX_M) {
      p.thickness = CURB_THICKNESS_DEFAULT_M;
    }
  }
}
